import { Component, Input } from '@angular/core';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-confirmation-modal',
  templateUrl: './confirmation-modal.component.html'
})
export class ConfirmationModalComponent {

  @Input() title: string;
  @Input() description: string;
  @Input() cancelLabel: string;
  @Input() confirmLabel: string;

  constructor(public activeModal: NgbActiveModal) { }

  cancel() {
    this.activeModal.dismiss(false);
  }

  confirm() {
    this.activeModal.close(true);
  }

}
